import { Component, Input } from '@angular/core';
import { TrainingCategoryModel } from '../../../../models/training-category.model';

@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrl: './payment-details.component.scss',
  standalone: false,
})
export class PaymentDetailsComponent {
  @Input() category: TrainingCategoryModel;
  @Input() totalAmount: number = 450.5;
}
